/* Mouthy Mule – tiny vanilla interactions. No libraries. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Scroll reveal (progressive enhancement).
     CSS shows everything by default. We only opt in to the hidden-then-reveal state when:
     motion is allowed, IntersectionObserver exists, and we are NOT inside the Shopify theme editor.
     Anything already on screen is revealed immediately, and a failsafe reveals all after 2.5s. */
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var canAnimate = !reduce && !designMode && ('IntersectionObserver' in window);
  var io = null, ioAlive = false;
  function revealAll() { document.querySelectorAll('.mm-reveal').forEach(function (e) { e.classList.add('is-in'); }); }
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.mm-reveal:not(.is-in)');
    if (!canAnimate) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var vh = window.innerHeight || document.documentElement.clientHeight;
    if (!io) io = new IntersectionObserver(function (entries) {
      ioAlive = true;
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.01, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) {
      var r = e.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) e.classList.add('is-in'); else io.observe(e);
    });
    document.documentElement.classList.add('mm-anim');
  }
  window.setTimeout(function () { if (!ioAlive) revealAll(); }, 2500);
  window.addEventListener('beforeprint', revealAll);

  /* Typing word swap */
  function initSwap(root) {
    (root || document).querySelectorAll('[data-mm-swap]').forEach(function (el) {
      if (el.dataset.ready) return; el.dataset.ready = 1;
      var words = (el.getAttribute('data-mm-swap') || '').split('|').map(function (w) { return w.trim(); }).filter(Boolean);
      var target = el.querySelector('.mm-swap__word');
      if (!words.length || !target || reduce) return;
      var wi = 0, ci = words[0].length, del = false;
      function tick() {
        var w = words[wi];
        if (!del) { ci++; if (ci > w.length) { del = true; return setTimeout(tick, 1700); } }
        else { ci--; if (ci === 0) { del = false; wi = (wi + 1) % words.length; return setTimeout(tick, 250); } }
        target.textContent = words[wi].slice(0, ci);
        setTimeout(tick, del ? 45 : 85);
      }
      setTimeout(function () { del = true; tick(); }, 2200);
    });
  }

  /* Hover tilt */
  function initTilt(root) {
    if (reduce || !window.matchMedia('(hover: hover) and (pointer: fine)').matches || window.matchMedia('(max-width: 989px)').matches) return;
    (root || document).querySelectorAll('[data-mm-tilt]').forEach(function (card) {
      if (card.dataset.ready) return; card.dataset.ready = 1;
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        var k = card.hasAttribute('data-mm-react') ? .5 : 1;
        card.style.transform = 'rotateX(' + (-y * 10 * k).toFixed(2) + 'deg) rotateY(' + (x * 12 * k).toFixed(2) + 'deg) translateY(-4px)';
      });
      card.addEventListener('pointerleave', function () { card.style.transform = ''; });
    });
  }

  /* Countdown */
  function initCountdown(root) {
    (root || document).querySelectorAll('[data-mm-countdown]').forEach(function (el) {
      if (el.dataset.ready) return; el.dataset.ready = 1;
      var end = new Date(el.getAttribute('data-mm-countdown')).getTime();
      if (isNaN(end)) return;
      var f = { d: el.querySelector('[data-d]'), h: el.querySelector('[data-h]'), m: el.querySelector('[data-m]'), s: el.querySelector('[data-s]') };
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function run() {
        var t = Math.max(0, end - Date.now());
        if (t <= 0) { var done = el.querySelector('[data-done]'); if (done) { done.hidden = false; el.querySelector('.mm-count__clock').hidden = true; } return; }
        f.d.textContent = pad(Math.floor(t / 864e5)); f.h.textContent = pad(Math.floor(t / 36e5) % 24);
        f.m.textContent = pad(Math.floor(t / 6e4) % 60); f.s.textContent = pad(Math.floor(t / 1e3) % 60);
        setTimeout(run, 1000);
      }
      run();
    });
  }

  /* Reviews carousel arrows */
  function initCarousel(root) {
    (root || document).querySelectorAll('[data-mm-carousel]').forEach(function (wrap) {
      if (wrap.dataset.ready) return; wrap.dataset.ready = 1;
      var track = wrap.querySelector('.mm-reviews__track');
      wrap.querySelectorAll('[data-dir]').forEach(function (b) {
        b.addEventListener('click', function () {
          var card = track.firstElementChild; var step = card ? card.getBoundingClientRect().width + 24 : 320;
          track.scrollBy({ left: step * Number(b.getAttribute('data-dir')), behavior: reduce ? 'auto' : 'smooth' });
        });
      });
    });
  }

  /* Quick add (inline size picker on cards) */
  function initQuickAdd(root) {
    (root || document).querySelectorAll('[data-mm-quick]').forEach(function (box) {
      if (box.dataset.ready) return; box.dataset.ready = 1;
      var toggle = box.querySelector('[data-mm-quick-toggle]'), sizes = box.querySelector('[data-mm-quick-sizes]');
      if (toggle && sizes) toggle.addEventListener('click', function () { sizes.hidden = false; toggle.hidden = true; });
      box.querySelectorAll('[data-variant]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var label = btn.textContent; btn.disabled = true; btn.textContent = '…';
          var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-variant')), quantity: 1 }], sections: 'cart-icon-bubble', sections_url: window.location.pathname })
          }).then(function (r) { return r.json(); }).then(function (res) {
            if (res.status) throw new Error(res.description || 'Could not add');
            btn.textContent = '✓';
            var bubble = document.getElementById('cart-icon-bubble');
            if (res.sections && res.sections['cart-icon-bubble'] && bubble) {
              var tmp = document.createElement('div'); tmp.innerHTML = res.sections['cart-icon-bubble'];
              var inner = tmp.querySelector('.shopify-section'); bubble.innerHTML = inner ? inner.innerHTML : tmp.innerHTML;
            }
            setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1600);
          }).catch(function (e) { btn.textContent = label; btn.disabled = false; alert(e.message); });
        });
      });
    });
  }

  /* Drawers (size guide) */
  function initDrawers() {
    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-mm-open]');
      if (open) { var d = document.getElementById(open.getAttribute('data-mm-open')); if (d) { if (d.parentElement !== document.body) document.body.appendChild(d); d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); var c = d.querySelector('.mm-drawer__close'); c && c.focus(); document.body.style.overflow = 'hidden'; } }
      if (e.target.closest('[data-mm-close]')) { var dr = e.target.closest('.mm-drawer'); dr.classList.remove('is-open'); dr.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') document.querySelectorAll('.mm-drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); document.body.style.overflow = ''; }); });
  }

  /* Sticky add to cart (mobile) */
  function initSticky() {
    var bar = document.querySelector('[data-mm-sticky-atc]'); if (!bar) return;
    var main = document.querySelector('product-form .product-form__submit, [data-mm-main-atc]');
    if (!main) return;
    bar.querySelector('button').addEventListener('click', function () { main.click(); if (main.disabled) main.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    new IntersectionObserver(function (en) { bar.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(main);
  }

  /* Newsletter thanks (preview only uses this; Shopify form posts normally) */
  function all(root) { initReveal(root); initSwap(root); initTilt(root); initCountdown(root); initCarousel(root); initQuickAdd(root); }
  document.addEventListener('DOMContentLoaded', function () { all(); initDrawers(); initSticky(); });
  document.addEventListener('shopify:section:load', function (e) { all(e.target); revealAll(); });
  document.addEventListener('shopify:section:select', revealAll);
  document.addEventListener('shopify:block:select', revealAll);
})();

/* v3-nav: header height var, back-to-top, load more */
(function(){
  function hh(){var h=document.querySelector('.section-header');if(h)document.documentElement.style.setProperty('--mm-header-h',h.offsetHeight+'px');}
  hh();addEventListener('resize',hh);
  var t=document.querySelector('[data-mm-top]');
  if(t){addEventListener('scroll',function(){t.hidden=scrollY<600},{passive:true});t.addEventListener('click',function(e){e.preventDefault();scrollTo({top:0,behavior:'smooth'})});}
  var grid=document.getElementById('product-grid');var pag=document.querySelector('.pagination-wrapper');
  if(grid&&pag){var next=pag.querySelector('a[aria-label*="ext"], .pagination__item-arrow:last-child');
    if(next&&next.href){var wrap=document.createElement('div');wrap.className='mm-loadmore';var b=document.createElement('button');b.type='button';b.textContent='Load more';wrap.appendChild(b);pag.parentNode.insertBefore(wrap,pag);
      var url=next.href;b.addEventListener('click',function(){b.disabled=true;b.textContent='Loading…';fetch(url).then(function(r){return r.text()}).then(function(h){var d=new DOMParser().parseFromString(h,'text/html');var g=d.getElementById('product-grid');if(g)Array.from(g.children).forEach(function(li){li.querySelectorAll('.scroll-trigger').forEach(function(e){e.classList.remove('scroll-trigger--offscreen');e.classList.remove('scroll-trigger')});li.querySelectorAll('.mm-reveal').forEach(function(e){e.classList.add('is-in')});grid.appendChild(li)});var n=d.querySelector('.pagination-wrapper a[aria-label*="ext"]');var np=d.querySelector('.pagination-wrapper');if(np)pag.innerHTML=np.innerHTML;if(n){url=n.href;b.disabled=false;b.textContent='Load more'}else wrap.remove()})});}}
})();
